import { defineMessages } from 'react-intl';

export default defineMessages({
  allDaySlotLabel: {
    id: 'components.myaccount.appointmentCalendar.allDaySlot',
    defaultMessage: 'All the day',
  },
});
